import type { Layout } from '@mentimeter/http-clients';

export const DEFAULT_FONT_OFFSET_TO_TITLE_HEIGHT: Record<
  Layout['font_size_offset'],
  number
> = {
  '-2': 64,
  '-1': 64,
  '0': 80,
  '1': 128,
  '2': 128,
};
